import { SupportedLanguages } from '../types';
import { getTwoLetterLanguageCode } from './index';

export const createSlug = ({
    language,
    uid = null,
    type = 'default',
}: {
    language: string;
    uid?: string | null;
    type?: 'home' | 'default';
}): string => {
    const languageAbbreviation = getTwoLetterLanguageCode(language);
    let result = '/';

    if (languageAbbreviation !== SupportedLanguages.en) {
        result += `${languageAbbreviation}/`;
    }

    if (type !== 'home') {
        result += `${uid}/`;
    }

    return result;
};
